import Vue from 'vue';
import { Component, Prop, Provide, Watch } from 'vue-property-decorator';
import Pager from '../../components/pager';
import template from './tasks.vue';
import tmsService from '../../services/axios/tmsService';
import tmsServiceBackend from '../../services/axios/tmsServiceBackend';
import switchBillingToService from '../../shared/switchBillingToService';
import tmsTransformRequestService from '../../services/axios/tmsTransformRequestService';
import qs from 'qs';
@Component({
    mixins: [template],
    components: {
        Pager,
    },
})
export default class Tasks extends Vue {
    billToId: any = '';
    searchParams: any = {
        page_size: 10,
        page: 1,
    };
    paging: any = {
        pageSize: 10,
        currentPage: 1,
        totalSize: 0,
        text: 'tasks',
    };
    taskArr: any = [];
    showErrTip: boolean = false;
    errorText: String = '';
    modalName: string = 'deleteTask';
    taskId: any = '';
    isGettingTaskList = false;

    mounted() {
        this.init();
    }

    init() {
        this.getUserBillToId();
    }

    getUserBillToId() {
        switchBillingToService.post().then(
            (res: any) => {
                if (res.data.billing) {
                    this.billToId = res.data.billing.location_id;
                    this.getTaskList(1);
                } else {
                    this.showErrorFun('BilltoId  error.');
                }
            },
            (err: any) => {
                this.showErrorFun('BilltoId  error.');
            }
        );
    }

    getList(page: any) {
        this.paging.pageSize = page.pageSize;
        this.getTaskList(page.currentPage);
    }

    getTaskList(page: number) {
        this.searchParams.page = page;
        this.isGettingTaskList = true;
        tmsServiceBackend
            .get(
                `/cpv2/task/getTasks?billto_id=${this.billToId}&page_size=${
                    this.paging.pageSize
                }&page=${this.searchParams.page}`
            )
            .then(
                (res: any) => {
                    this.taskArr = res.data.data.data;
                    this.paging.currentPage = res.data.data.current_page;
                    this.paging.totalSize = res.data.data.total;
                    this.paging.pageSize = res.data.data.per_page;
                    this.isGettingTaskList = false;
                },
                (err: any) => {
                    this.isGettingTaskList = false;
                    this.showErrorFun('Get tasks error.');
                }
            );
    }

    deleteTask() {
        tmsServiceBackend.get(`/cpv2/task/delete/${this.taskId}`).then(
            (res: any) => {
                console.log(res);
            },
            (err: any) => {
                this.showErrorFun('Delete  failed.');
            }
        );
    }

    generateBOL(item: any) {
        this.$router.push({
            name: 'Billoflading',
            params: {
                orderId: item.tms_order_id,
            },
        });
    }

    closeTips() {
        this.showErrTip = false;
    }

    showErrorFun(errText: any) {
        this.errorText = errText;
        this.showErrTip = true;
        setTimeout(() => {
            this.showErrTip = false;
        }, 3000);
    }

    reference(item: any) {
        localStorage.setItem('ShipmentViewFrom', '3');
        this.$router.push({
            name: 'ShipmentView',
            params: {
                orderId: item.tms_order_id,
                from: '3',
            },
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/layouts/tasks/index.ts